import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Slide,
    Box,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { topupBalance } from '../../../Services/authService';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '../../../Context/ThemeContext';
import { DARKCOLORS, LIGHTCOLORS } from '../../../Utils/constants';
import { StyledTextField } from '../../../Components/Common/StyledTextField';

// Slide Transition Function
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="top" ref={ref} {...props} timeout={800} />;
});

export default function BalanceSection({ cardNumber, isEditMode, balance, onBalanceChange }) {
    const { t } = useTranslation();
    const { mode } = useThemeContext();

    const btnColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
    const modalBackgroundColor = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
    const inputBoxColor = mode === 'dark' ? DARKCOLORS.GreyScale10 : LIGHTCOLORS.GreyScale10;
    const btnColor1 = mode === 'dark' ? DARKCOLORS.Primary100 : LIGHTCOLORS.Primary100;

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [amount, setAmount] = useState('');
    const [error, setError] = useState('');
    const [updateBalance, setUpdateBalance] = useState(null);

    const handleChange = (e) => {
        const value = e.target.value;
        if (!/^\d*\.?\d*$/.test(value)) return; // Allow only numeric values
        setAmount(value);
    };

    // const handleAddMoney = async () => {
    //     const cleanedAmount = parseFloat(amount);
    //     if (!amount || isNaN(cleanedAmount) || cleanedAmount <= 0) {
    //         setError('Please enter a valid positive amount.');
    //         return;
    //     }
    //     try {
    //         await topupBalance(cardNumber, cleanedAmount);
    //         const updatedBalance = parseFloat(balance) + cleanedAmount;
    //         onBalanceUpdate(updatedBalance.toFixed(2)); // Ensure balance format remains consistent
    //         setIsModalOpen(false);
    //         setAmount('');
    //         setError('');
    //     } catch (error) {
    //         console.error('Failed to add money:', error);
    //         setError('Failed to add money. Please try again.');
    //     }
    // };

    const handleAddMoney = async () => {
        const cleanedAmount = parseFloat(amount);
        if (!amount || isNaN(cleanedAmount) || cleanedAmount <= 0) {
            setError(t('membershipCards.Pleasevalidpositive'));
            return;
        }
        try {
            const response = await topupBalance(cardNumber, cleanedAmount);
            if (response) { // Assuming the API returns some confirmation
                const updatedBalance = Number(balance || 0) + cleanedAmount;
                setUpdateBalance(updatedBalance)
                onBalanceChange(updatedBalance);
                setIsModalOpen(false);
                setAmount('');
                setError('');
            } else {
                setError(t('membershipCards.Pleasevalidpositive'));
            }
        } catch (error) {
            console.error(t('membershipCards.failedAddMoney'), error);
            setError(error.message || t('membershipCards.Pleasevalidpositive'));
        }
    };


    return (
        <>
            {isEditMode ? (
                <>
                    <Box className="membership-add-money"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            backgroundColor: inputBoxColor,
                            borderRadius: '6px',
                            padding: '8px 16px',
                            width: "50%",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography>
                            € {(updateBalance ?? Number(balance) ?? 0).toFixed(2)}
                        </Typography>

                        <button
                            type="button"
                            className='add-money-btn'
                            style={{
                                background: btnColor1, // Light purple background
                                border: 'none',
                                borderRadius: '18px',
                                padding: '4px 12px',
                                fontWeight: '500',
                                cursor: 'pointer',
                             
                            }}
                            onClick={() => setIsModalOpen(true)}
                        >
                            {t('membershipCards.AddMoney')}
                        </button>
                    </Box>

                </>
            ) : (
                <Box sx={{ width: "50%" }}>
                    <StyledTextField
                        label={`€ ${t('membershipCards.balance')}`}
                        name="balance"
                        numberType="number"
                        value={balance}
                        onChange={(e) => onBalanceChange(e.target.value)}
                        disabled
                        inputBoxColor={inputBoxColor}
                        required
                    />
                </Box>
            )}

            {/* Add Money Modal */}
            <Dialog
                open={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                fullWidth
                maxWidth="sm"
                TransitionComponent={Transition}
                PaperProps={{
                    sx: {
                        position: 'absolute',
                        right: 10,
                        margin: 0,
                        borderRadius: 3,
                        background: modalBackgroundColor,
                    },
                }}
            >
                <DialogTitle sx={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: {
                        xs: 2,  // base padding
                        sm: 3,  // small screens
                        md: "20px 24px ",
                    }
                }}>
                    <Typography variant='h6'>{t('membershipCards.AddMoney')}</Typography>
                    <IconButton onClick={() => setIsModalOpen(false)} aria-label="close">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{
                    overflowY: 'auto', paddingTop: 2, p: {
                        xs: 2,  // base padding
                        sm: 3,  // small screens
                        md: "20px 24px ",
                    }
                }}>
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        {t('membershipCards.enterAmount')}
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 2, alignItems: "center" }}>
                        <StyledTextField
                            label={t('membershipCards.Amountplaceholder')}
                            name="amount"
                            numberType="number"
                            value={amount}
                            onChange={handleChange}
                            inputBoxColor={inputBoxColor}
                            required
                        />
                        <button
                            type="button"
                            style={{ background: btnColor }}
                            className='save-btn membershipCards-add-money-btn'
                            onClick={handleAddMoney}
                            // sx={{ width: "150px", height: "40px" }}
                        >
                            {t('membershipCards.Add')}
                        </button>
                    </Box>

                    {error && (
                        <Typography
                            variant="body2"
                            color="error"
                            sx={{ mt: 1, textAlign: 'center' }}
                        >
                            {error}
                        </Typography>
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
}